import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeCompanySelection } from "../../../auth/actions/userActions";
import { useNavigate } from "react-router-dom";

const SelectorUnit = () => {
    const companies = useSelector((state) => state.user.companies);
    const company = useSelector((state) => state.user.company);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // O clique é tratado pelo próprio Menu (e não por um <button> dentro do
    // label): assim os itens herdam as cores do tema do antd — um botão com
    // `all: unset` zerava a cor herdada e ficava ilegível no modo escuro.
    const handleMenuClick = useCallback(
        ({ key }) => {
            const item = companies.find((c) => String(c.unitId) === key);
            if (item && item.unitId !== company?.unitId) {
                dispatch(changeCompanySelection(item, navigate));
            }
        },
        [companies, company, dispatch, navigate]
    );

    const menuItems = useMemo(
        () => [
            {
                key: "title",
                type: "group",
                label: "Selecione sua unidade",
            },
            ...companies.map((item) => ({
                key: String(item.unitId),
                label: (
                    <>
                        <b>{item.companyName}</b> - <b>{item.unitName}</b>
                    </>
                ),
            })),
        ],
        [companies]
    );

    const selectedKeys = company ? [String(company.unitId)] : [];

    return companies.length > 1 ? (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick, selectable: true, selectedKeys }}
            placement="bottomLeft"
        >
            <button type="button" style={{ all: "unset", cursor: "pointer", color: "inherit" }}>
                <Space>
                    {company ? (
                        <>
                            <b>{company.companyName}</b> - <b>{company.unitName}</b>
                        </>
                    ) : (
                        <p>Selecione sua unidade</p>
                    )}
                    <DownOutlined />
                </Space>
            </button>
        </Dropdown>
    ) : (
        <p>
            {company ? (
                <span>
                    <b>{company.companyName}</b> - <b>{company.unitName}</b>
                </span>
            ) : (
                "Nenhuma unidade disponível"
            )}
        </p>
    );
};

export default SelectorUnit;
